import { SiteHeader } from '../../shared/components/SiteHeader';
import { SiteFooter } from '../../shared/components/SiteFooter';
import { PageHero } from '../../shared/components/PageHero';
import { MapSection } from '../../shared/components/MapSection';
import styles from './AboutPage.module.css';
import heroImage from '../../../assets/about/hero.png';
import profileImage from '../../../assets/about/profile.png';

const PROFILE_MESSAGE: readonly string[] = [
  '私たちは、テクノロジーの進化によって、資産形成の在り方も大きく変化していく時代にあると考えています。情報が溢れ、相場変動も激しくなる中で、感情や経験だけに頼った投資判断には限界がある一方、AIやデータ分析を活用することで、より合理的な判断を支援できる可能性が広がっています。',
  'CJインベストメント株式会社では、AIを活用した運用支援と、金融知見に基づくウェルスマネジメントを組み合わせ、一人ひとりに寄り添った資産形成支援を目指しています。私たちは単にシステムを提供するのではなく、お客様が長期的に安心して資産形成に向き合える環境づくりを大切にしています。',
  'また、資産形成において本当に重要なのは、短期的な成果だけではなく、継続性や再現性、そして信頼できるパートナーの存在だと考えています。そのため、テクノロジーだけに依存するのではなく、人によるサポートやコミュニケーションも重視しながら、長期的な視点での支援を行っています。',
  'これからも、ITと金融の両面から価値提供を行い、変化の激しい時代においても、お客様に安心して選んでいただける存在を目指してまいります。',
];

const CAREER_HISTORY: readonly string[] = [
  '1994年　山一證券に入社、債権部で先物OPディーラーを担当',
  '2007年　HSBC香港上海銀行に入社、個人金融本部で富裕層向け投資アドバイザーを担当',
  '2017年　CJインベストメント株式会社を設立',
];

type CompanyRow = {
  readonly label: string;
  readonly value: string;
};

const COMPANY_INFO: readonly CompanyRow[] = [
  {
    label: '会社名',
    value: 'CJインベストメント株式会社（英文名称：CJ Investment Corporation）',
  },
  {
    label: '所在地',
    value: '〒222-0033　神奈川県横浜市港北区新横浜2-5-4 京浜建物第2ビル504',
  },
  { label: '資本金', value: '1,000万円' },
  { label: '設立', value: '2017年1月' },
  { label: '従業員数', value: '3名（2022年7月現在）' },
  { label: '取引銀行', value: 'スルガ銀行、湘南信用金庫' },
];

export const AboutPage = (): JSX.Element => {
  return (
    <div className={styles.page}>
      <SiteHeader variant="overlay" tone="light" />

      <PageHero image={heroImage} eyebrow="COMPANY" title="会社概要" />

      <section className={styles.profile}>
        <div className={styles.sectionHead}>
          <p className={styles.eyebrow}>PROFILE</p>
          <h2 className={styles.sectionTitle}>代表紹介</h2>
        </div>
        <div className={styles.profileBody}>
          <img
            className={styles.profileImage}
            src={profileImage}
            alt="代表取締役 李 松"
          />
          <div>
            <div className={styles.profileMessage}>
              {PROFILE_MESSAGE.map((paragraph) => (
                <p key={paragraph.slice(0, 12)}>{paragraph}</p>
              ))}
            </div>
            <div className={styles.profileSign}>
              <p className={styles.signRole}>代表取締役</p>
              <p className={styles.signName}>李 松</p>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.career}>
        <div className={styles.careerBox}>
          <div className={styles.sectionHead}>
            <p className={styles.eyebrow}>CAREER</p>
            <h2 className={styles.sectionTitle}>経歴</h2>
          </div>
          <div className={styles.careerList}>
            {CAREER_HISTORY.map((entry) => (
              <p key={entry}>{entry}</p>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.company}>
        <div className={`${styles.sectionHead} ${styles.companyHead}`}>
          <p className={styles.eyebrow}>ABOUT COMPANY</p>
          <h2 className={styles.sectionTitle}>企業情報</h2>
        </div>
        <table className={styles.infoTable}>
          <tbody>
            {COMPANY_INFO.map((row) => (
              <tr key={row.label}>
                <th scope="row">{row.label}</th>
                <td>{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <MapSection />

      <SiteFooter bordered />
    </div>
  );
};
